<template>
  <header>
    <div class="header" :class="{ BAM: isBAM }" id="headerRippleWrap">
      <h1 @click="changeHash('blog')" class="iconfont icon-fepawn"></h1>
      <div class="headerR">
        <div
          class="search"
          v-show="searchIsShow"
          :class="{ active: slideDown }"
        >
          <i class="iconfont icon-sousuo" @click="showSearch"></i>
          <input
            type="text"
            placeholder="输入搜索内容回车"
            v-model="searchInfo"
            @keydown.stop.enter="searchSubmit"
          />
        </div>
        <div class="logout ripple" @click="logout" v-if="userID">
          <i class="iconfont icon-git46"></i>
          <span class="Tooltip">退出</span>
        </div>
        <div
          class="person"
          :class="{ activeType: activeRoute.indexOf('/BAM') > -1 }"
          @click="changeHash('BAM')"
        >
          <div class="info">
            <div class="avatar"><img :src="avatar" alt="" /></div>
          </div>
          <span class="Tooltip">个人中心</span>
        </div>
      </div>
      <nav class="nav">
        <ul v-show="navListIsShow">
          <li
            class="ripple"
            :class="{
              activeType: activeRoute === '/blog' || activeRoute === '/article'
            }"
            @click="changeHash('blog')"
          >
            <i class="iconfont icon-home1149866easyiconnet"></i>
            <span class="info">博客</span>
            <div class="rippleWrap">
              <span></span>
            </div>
          </li>
          <li
            class="ripple"
            :class="{ activeType: activeRoute === '/time' }"
            @click="changeHash('time')"
          >
            <i class="iconfont icon-emizhifeiji"></i>
            <span class="info">归档</span>
            <div class="rippleWrap">
              <span></span>
            </div>
          </li>
          <li
            class="ripple"
            :class="{ activeType: activeRoute === '/code' }"
            @click="changeHash('code')"
          >
            <i class="iconfont icon-insert_tag_field"></i>
            <span class="info">代码段</span>
            <div class="rippleWrap">
              <span></span>
            </div>
          </li>
        </ul>
      </nav>
    </div>
    <v-Message
      :messageShow="messageShow"
      :sendMessage="sendMessage"
    ></v-Message>
  </header>
</template>

<script>
import defaultAvatar from "@/assets/img/defaultIcon.png";
import { ripple } from "@/assets/script/common";
import Message from "@/components/common/Message/Message";
import { bmobLogout } from "@/bmob";

export default {
  data() {
    return {
      activeRoute: "/blog",
      searchInfo: "",
      isBAM: false,
      navListIsShow: true,
      searchIsShow: true,
      messageShow: false,
      sendMessage: "",
      slideDown: false,
      avatar: defaultAvatar,
      userID: ""
    };
  },
  watch: {
    $route(to, from) {
      // 获取用户信息
      this.getUserInfo();
      this.activeRoute = to.path;
      // 判断是否是后台管理界面
      if (to.path.indexOf("/BAM") > -1) {
        this.isBAM = true;
        this.navListIsShow = true;
        this.searchIsShow = false;
      } else {
        this.isBAM = false;
        this.navListIsShow = true;
        this.searchIsShow = true;
      }
      // 判断是否是login界面
      if (to.path.indexOf("/login") !== -1) {
        this.activeRoute = "/BAM";
      }
    },
    // 监听搜索关键词
    "$route.query.keyWord": {
      immediate: true, //  关键，，将立即以表达式的当前值触发回调
      handler(val) {
        // 搜索框关键词回填
        this.searchInfo = val;
        // 展示搜索框
        this.slideDown = val ? true : false;
      }
    }
  },
  methods: {
    // 获取用户信息
    getUserInfo() {
      this.userID = window.localStorage.getItem("userId") || "";
      this.avatar = this.userID
        ? window.localStorage.getItem("avatar")
        : defaultAvatar;
    },
    logout() {
      bmobLogout()
        .then(result => {
          if (result.code === "000") {
            //清除本地存储
            localStorage.clear();
            // 获取用户信息
            this.getUserInfo();
            //重新获取文章字数
            this.$emit("getWordCount");
            let routeQuery = this.$route.query;
            let routePath = this.$route.path;
            if (routePath.indexOf("/BAM") > -1) {
              //如果是需要权限的路由就跳转首页
              this.$router.replace({ path: "/blog", query: routeQuery });
            } else {
              //简单刷新操作
              window.location.reload();
            }
            if (!this.messageShow) {
              this.messageShow = true;
              this.sendMessage = result.message;
              setTimeout(() => {
                this.messageShow = false;
              }, 1500);
            }
          }
        })
        .catch(err => {
          if (err.code === "001") {
            if (!this.messageShow) {
              this.messageShow = true;
              this.sendMessage = err.message;
              setTimeout(() => {
                this.messageShow = false;
              }, 1500);
            }
          }
        });
    },
    // 获取用户id
    getUserId() {
      return (
        window.localStorage.getItem("userId") ||
        this.$route.query.userId ||
        undefined
      );
    },
    changeHash(type) {
      const userId = this.getUserId();
      const keyWord = this.$route.query.keyWord || "";
      if (type === "BAM") {
        this.$router.push({ path: "/" + type });
        return;
      }
      let query = {};
      userId && (query.userId = userId);
      keyWord && (query.keyWord = keyWord);
      // BAM后台时点击logo，则添加上用户id
      if (this.isBAM && type === "blog") {
        this.$router.push({ path: "/blog", query });
        return;
      }
      this.$router.push({ path: "/" + type, query });
    },
    showSearch(e) {
      e.target.nextElementSibling.focus();
      this.slideDown = this.slideDown ? false : true;
    },
    searchSubmit() {
      // 获取用户id
      const userId = this.getUserId();
      // 获取搜索关键字
      this.searchInfo = this.searchInfo.trim();
      let query = {};
      //如果有用户id加上
      if (userId) {
        query.userId = userId;
      }
      //有搜索关键词加上
      if (this.searchInfo) {
        query.keyWord = this.searchInfo;
      }
      this.$router.push({ path: "/blog", query }); //跳转到博客文章列表
    }
  },
  mounted() {
    // 获取用户信息
    this.getUserInfo();
    // 判断是否是BAM界面
    if (this.$route.path.indexOf("/BAM") > -1) {
      this.activeRoute = this.$route.path;
      this.isBAM = true;
      // this.navListIsShow = false;
      this.searchIsShow = false;
    }
    // 判断是否是login界面
    if (this.$route.path.indexOf("/login") !== -1) {
      this.activeRoute = "/BAM";
    }
    // 判断是否是time界面
    if (this.$route.path.indexOf("/time") !== -1) {
      this.activeRoute = "/time";
    }
    // 判断是否是code界面
    if (this.$route.path.indexOf("/code") !== -1) {
      this.activeRoute = "/code";
    }
    ripple("headerRippleWrap");
  },
  components: {
    "v-Message": Message
  }
};
</script>

<style lang="less">
@import "../../../assets/style/common.less";
@m26a69a: #26a69a;
@m009688: #009688;
.header {
  position: fixed;
  z-index: 990;
  top: 0;
  left: 0;
  right: 0;
  background-color: @m26a69a;
  height: 50px;
  color: #fff;
  box-shadow: 0px 0px 10px #000;
  &.BAM {
    left: 200px;
    right: 0;
    z-index: 10000;
    background-color: #fff;
    color: #2f4050;
  }
  h1 {
    margin-left: 100px;
    float: left;
    font-size: 30px;
    line-height: 50px;
    width: 160px;
    cursor: pointer;
  }
  .nav {
    max-width: 1024px;
    margin: 0 auto;
    .rippleMixin(20px, 50px, rgba(255, 255, 255, 0.2), 200, nav);
    ul {
      .clearfixMixin();
      li {
        float: left;
        line-height: 50px;
        &.activeType,
        &:hover {
          background-color: rgba(0, 0, 0, 0.1);
        }
        i {
          display: inline-block;
          margin-right: 3px;
          font-size: 17px;
          line-height: 21px;
          vertical-align: middle;
        }
      }
    }
  }
  .headerR {
    float: right;
    margin-right: 20px;
    .search {
      float: left;
      width: 44px;
      height: 50px;
      overflow: hidden;
      background-color: @m26a69a;
      font-size: 0;
      padding: 12px 10px 0 15px;
      box-sizing: border-box;
      transition: all 0.5s;
      i {
        float: left;
        line-height: 26px;
        font-size: 18px;
        &:hover {
          cursor: pointer;
        }
      }
      .placeholder(#fff);
      input {
        float: right;
        width: 0;
        border: 0;
        font-size: 14px;
        height: 26px;
        box-sizing: border-box;
        color: #fff;
        background-color: transparent;
        transition: all 0.5s;
      }
      &.active {
        width: 190px;
        background-color: @m009688;
        input {
          width: 145px;
          padding-left: 10px;
        }
      }
    }
    .person {
      float: right;
      height: 50%;
      cursor: pointer;
      position: relative;
      transition: all 1s;
      .Tooltip {
        display: none;
      }
      &:hover {
        .TooltipMixin(70px, -45px, 0, 6px, 6px, 7px);
        .Tooltip {
          display: block;
        }
      }
      .info {
        width: 50px;
        height: 50px;
        padding: 8px;
        display: inline-block;
        box-sizing: border-box;
        vertical-align: top;
        .avatar {
          overflow: hidden;
        }
        img {
          height: 34px;
          border-radius: 100%;
        }
      }
      &.activeType,
      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
    .rippleMixin(0, 50px, rgba(255, 255, 255, 0.2), 200, logout);
    .logout {
      float: left;
      width: 50px;
      height: 50px;
      text-align: center;
      cursor: pointer;
      .Tooltip {
        display: none;
      }
      &:hover {
        .Tooltip {
          display: block;
        }
        background-color: rgba(0, 0, 0, 0.1);
      }
      .iconfont {
        font-size: 27px;
        line-height: 50px;
      }
      .TooltipMixin(50px, -45px, 0, 6px, 6px, 7px);
    }
  }
}

@media (max-width: 1024px) {
  .header {
    box-shadow: unset;
    &.BAM {
      left: 0;
    }
    h1 {
      width: 180px !important;
      margin-left: 15px;
      display: none;
    }
    .nav {
      overflow-x: auto;
      overflow-y: hidden;
      ul {
        display: flex;
        li.ripple {
          padding: 0 2px;
          text-align: center;
          i {
            margin-right: 0;
          }
        }
      }
    }
    .rippleWrap {
      position: unset !important;
      width: 70px !important;
    }
    .search {
      // display: none;
    }
    .headerR {
      margin-right: 5px;
      .person {
        &:hover {
          .Tooltip {
            display: none;
          }
        }
        .info {
          width: auto;
        }
      }
      .logout {
        &:hover {
          .Tooltip {
            display: none;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// header.vue?1559d0cd